export default "__VITE_ASSET__b163412a__"